module.exports = __webpack_public_path__ + "img/o-taiwan-m.c47f3379.png";